import { Deserializable } from '../../deserializable';

export class MortgageOfferDocumentDto implements Deserializable {
  public MortgageOfferDocumentIdHash: string;
  public DocumentFriendlyName: string;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
